import { Component, Injector, OnInit } from '@angular/core';
import { EntityService } from '../../../entities/services/entity.service';
import { EntityModel } from '../../../entities/models/entity-model';
import { RouteService } from '../../../routing/services/route.service';
import { ToastService } from '../../../toast/services/toast.service';

@Component({
    selector: 'chassis-entities-index-page',
    templateUrl: './entity-index.page.html',
    styleUrls: ['./entity-index.page.scss'],
    providers: [EntityService]
})
export class EntityIndexPage implements OnInit {

    /**
     * The page title.
     *
     * @type {string}
     */
    protected title = 'Entities';

    /**
     * The route prefix.
     */
    protected routePrefix = 'entities';

    /**
     * The plugin slot prefix.
     *
     * @type {string}
     */
    protected pluginPrefix = 'chassis-entities-entities-index';

    /**
     * The ProductModel instance.
     *
     * @type {ProductModel}
     */
    public model: EntityModel = new EntityModel;

    /**
     * The ProductService instance.
     */
    protected entityService: EntityService;

    /**
     * The RouteService instance.
     */
    protected routeService: RouteService;

    /**
     * The ToastService instance.
     */
    protected toastService: ToastService;

    /**
     * Table object to override defaults or to add functionality.
     */
    protected table = {
        service: null,
        columns: null
    };

    /**
     * Constructor.
     *
     * @param injector
     */
    constructor(protected injector: Injector) {
        this.entityService = this.injector.get(EntityService);
        this.routeService  = this.injector.get(RouteService);
        this.toastService  = this.injector.get(ToastService);
    }

    /**
     * OnInit.
     */
    ngOnInit() {
        this.createDatatable();
    }

    /**
     * Create the datatable.
     */
    protected createDatatable() {
        this.table = {
            service: this.entityService,
            columns: [
                {name: 'icon', data: 'icon', title: '', width: '100px', searchable: false, visible: true},
                {name: 'name', data: 'name', title: 'Entity name', searchable: true, visible: true, filter: {filter_type: 'text', filter_delay: 1000}}
            ]
        };

        this.createDatatableCallbacks();
        this.createDatatableFilters();
    }

    /**
     * Set datatable callbacks.
     */
    protected createDatatableCallbacks() {
        // this.table.callbacks['click'] = (model, row, index) => {};
    }

    /**
     * Create datatable filters.
     */
    protected createDatatableFilters() {
        // this.table.filters = [];
    }

}


// WEBPACK FOOTER //
// ./libs/chassis-core/src/app/pages/entities/index/entity-index.page.ts